<template>
    <modal
        v-if="showModal"
        :allow-cancel="false"
        :allow-escape="true"
        @closed="closed"
        :enable-close-button="true">

        <div v-if="showWaitListText" class="text-center">
            <p v-text="$t('DELIVERY_WAITING_LIST_MODAL_SORRY')"></p>
            <p v-text="$t('DELIVERY_WAITING_LIST_MODAL_WOULD_YOU')"></p>
        </div>
        <div v-else class="text-center">
            <h2 v-if="hasSignedUp" v-text="$t('DELIVERY_WAITING_LIST_MODAL_PERFECT')"></h2>
            <h2 v-else v-text="$t('DELIVERY_WAITING_LIST_MODAL_NOT_A_PROBLEM')"></h2>

            <p v-text="$t('DELIVERY_WAITING_LIST_MODAL_MEANTIME')" v-if="!isUSA"></p>
        </div>

        <!-- <template v-slot> can only appear at the root level inside the receiving the component -->
        <template v-slot:actions-suffix>
            <div v-if="showWaitListText" class="w-full flex justify-center">
                <button
                    class="btn btn--primary btn--full-width sm:w-auto my-1 sm:my-0 sm:mx-1"
                    @click="AddIncompleteRegistrantToWaitingList()"
                    v-text="$t('DELIVERY_WAITING_LIST_MODAL_SOUNDS_GOOD')"></button>
                <button
                    class="btn btn--secondary btn--full-width sm:w-auto my-1 sm:my-0 sm:mx-1"
                    @click="hideJoinWaitingListForm()"
                    v-text="$t('DELIVERY_WAITING_LIST_MODAL_NO_THANKS')"></button>
            </div>
            <div v-else class="w-full flex justify-center">
                <a  v-if="!isUSA"
                    href="https://blog.freddiesflowers.com/"
                    class="text-center btn btn--primary btn--full-width sm:w-auto"
                    v-text="$t('DELIVERY_WAITING_LIST_MODAL_BLOG')"></a>
            </div>
        </template>
    </modal>
</template>
<script>
import Modal from '@/components/structure/Modal';
import WaitingListService from '@/services/cms/WaitingListService';

let waitingListService = new WaitingListService();

export default {
    name: 'DeliveryWaitingListModal',
    props: {
        postcode: {
            default: null,
            type: String,
        },
        showModal: {
            default: false,
            type: Boolean,
        },
        joinWaitList: {
            default: false,
            type: Boolean,
        },
    },
    data() {
        return {
            hasSignedUp: false,
            joinWaitingListFormVisible: true,
        };
    },
    computed: {
        coupon() {
            return this.$store.getters['register/getCoupon'];
        },

        email() {
            return this.$store.getters['register/getEmail'];
        },

        firstName() {
            return this.$store.getters['register/getFirstName'];
        },

        lastName() {
            return this.$store.getters['register/getLastName'];
        },
        isUSA() {
            return this.$store.getters['localisation/isUSA'];
        },
        showWaitListText() {
            return this.joinWaitList || this.joinWaitingListFormVisible;
        },
    },
    methods: {
        AddIncompleteRegistrantToWaitingList() {
            waitingListService
                .addUserToWaitingList({
                    couponCode: this.coupon ? this.coupon.code : null,
                    couponSource: this.coupon ? this.coupon.source : null,
                    email: this.email,
                    firstName: this.firstName,
                    lastName: this.lastName,
                    postcode: this.postcode,
                })
                .then(() => {
                    this.incompleteRegistrantHasSignedup();
                    this.hideJoinWaitingListForm();
                });
        },

        hideJoinWaitingListForm() {
            this.joinWaitingListFormVisible = false;
            this.$emit('hideJoinList');
        },

        incompleteRegistrantHasSignedup() {
            this.hasSignedUp = true;
        },

        closed() {
            this.hasSignedUp = false;
            this.$emit('closed')
        },
    },
    components: {
        Modal,
    },
};
</script>
